import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../../../../../selectors/layout';
import { selectServiceVerticalCardsExperiment } from '../../../../../../../../selectors/experiments';

export const useVerticalServices = () => {
  const isMobile = useSelector(selectIsMobileLayout);
  const inExperiment = useSelector(selectServiceVerticalCardsExperiment);

  const showVerticalServices = isMobile && inExperiment;

  return {
    showVerticalServices,
  };
};
